import {Component, Prop, Vue} from 'vue-property-decorator'
import {AnalysisVO} from '@/valueObjects/AnalysisVO'
import AnalysisServiceMixin from '@/services/AnalysisServiceMixin'
import ReportValidator from '@/utils/validators/ReportValidator'
import {INVALID_VALUE_GUI_MARK} from '@/utils/constants'


@Component({
    mixins: [AnalysisServiceMixin],
})
export default class AnalysisMemdumps extends Vue {
    @Prop()
    private analysis: AnalysisVO
    
    private hasdump(){
        return this.analysis
            && this.analysis.dynamicReport
            && this.analysis.dynamicReport.memory_dumps
    }
}